import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Theme, ThemeStore } from './useTheme.types';

const applyTheme = (theme: Theme) => {
  if (typeof document !== 'undefined') {
    const html = document.documentElement;
    if (theme === 'dark') {
      html.classList.remove('light');
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
      html.classList.add('light');
    }
  }
};

export const useTheme = create<ThemeStore>()(
  persist(
    (set, get) => ({
      theme: 'light',
      mounted: false,
      setTheme: (theme: Theme) => {
        set({ theme });
        applyTheme(theme);
      },
      toggleTheme: () => {
        const { theme } = get();
        const newTheme = theme === 'light' ? 'dark' : 'light';
        set({ theme: newTheme });
        applyTheme(newTheme);
      },
      initTheme: () => {
        if (typeof window !== 'undefined') {
          if (get().mounted) {
            return;
          }

          const savedTheme = localStorage.getItem('theme-storage');
          let initialTheme: Theme = 'light';

          if (savedTheme) {
            try {
              const parsed = JSON.parse(savedTheme);
              initialTheme = parsed.state?.theme || 'light';
            } catch {
              initialTheme = 'light';
            }
          } else {
            initialTheme = 'light';
          }

          set({ theme: initialTheme, mounted: true });
          applyTheme(initialTheme);
        }
      },
    }),
    {
      name: 'theme-storage',
      partialize: (state) => ({ theme: state.theme }),
    }
  )
);
